export default __webpack_public_path__ + "static/media/標準旅行業約款.0aa0aa66.pdf";